import { ProfileData } from '../types';

export const userBData: ProfileData = {
  profile: {
    title: "Profile - Modern Style",
    name: "Sarah Johnson",
    searchPlaceholder: "Try 'adventure and creativity'"
  },
  photos: [
    {
      url: "/assets/userB/photo1.jpg",
      alt: "Profile photo 1",
      gradient: "linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%)"
    },
    {
      url: "/assets/userB/photo2.jpg",
      alt: "Profile photo 2",
      gradient: "linear-gradient(135deg, #4ecdc4 0%, #44a08d 100%)"
    },
    {
      url: "/assets/userB/photo3.jpg",
      alt: "Profile photo 3",
      gradient: "linear-gradient(135deg, #ffe66d 0%, #ff6b6b 100%)"
    },
    {
      url: "/assets/userB/photo4.jpg",
      alt: "Profile photo 4",
      gradient: "linear-gradient(135deg, #a8e6cf 0%, #7fcdcd 100%)"
    }
  ],
  cards: [
    {
      id: "numbers",
      type: "numbers",
      title: "Social Stats",
      items: [
        { label: "Instagram", value: "5,623" },
        { label: "LinkedIn", value: "1,247" },
        { label: "TikTok", value: "3,891" },
        { label: "YouTube", value: "892" }
      ],
      special: {
        label: "Digital ID",
        value: "#9,847,362,150"
      }
    },
    {
      id: "travel",
      type: "simple",
      title: "Travel Adventures",
      text: "Exploring new cultures and hidden gems around the world"
    },
    {
      id: "photography",
      type: "image",
      title: "Photography",
      content: "📸 Capturing moments",
      height: "200px",
      background: "linear-gradient(135deg, #ff6b6b, #ee5a52)",
      fontSize: "24px"
    },
    {
      id: "music-quote",
      type: "quote",
      quote: "Music is the soundtrack to life's greatest adventures.",
      author: "Personal philosophy"
    },
    {
      id: "creativity",
      type: "quote",
      quote: "Art is not what you see, but what you make others see.",
      author: "Edgar Degas"
    }
  ]
};

